import { Component, OnInit, AfterViewInit, OnChanges, OnDestroy, SimpleChanges, HostListener } from '@angular/core';
import { LoadingService } from './services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { GeneralService } from './services/general.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnChanges, OnDestroy {
  title = 'ng-uikit-pro-standard';
  isNavCollapse = false;
  visibleNav: boolean;
  userMenu: any;
  onlySubMenu: any;

  private inactivityTimer: any;
  private readonly INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutos

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:touchstart')
  resetInactivityTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(() => {
      if (localStorage.getItem('token')) {
        localStorage.clear();
        this.router.navigate(['/logincubeworks']);
      }
    }, this.INACTIVITY_TIMEOUT);
  }

  constructor(
    public loadingService: LoadingService,
    public translate: TranslateService,
    private router: Router,
    private generalService: GeneralService, public userService: UserService
  ) {
    translate.setDefaultLang('en');

    this.generalService.currentUrl.next(this.router.url);
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.generalService.previousUrl.next(this.generalService.currentUrl.value);
        this.generalService.currentUrl.next(event.url);
      };

    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented changeee.');
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   console.log('windowwwww', event);
  //   // this.innerWidth = window.innerWidth;
  // }

  ngOnDestroy() {
    clearTimeout(this.inactivityTimer);
  }

  ngAfterViewInit() {
    this.resetInactivityTimer();
    var mythis = this;
    const menu = localStorage.getItem('userMenu');
    if (!menu) {

      var mytoken = localStorage.getItem('token');

      if(mytoken){
        mythis.userService.getMenu().subscribe((data) => {
          localStorage.setItem('userMenu', JSON.stringify(data));
          mythis.loadMenu();
        });
  
      }

    }
    else {
      mythis.loadMenu();
    }
  }

  loadMenu() {

    var mythis = this
    this.onlySubMenu = [];
    this.userMenu = JSON.parse(localStorage.getItem('userMenu'));
    this.userMenu.userMenuNodes.forEach(function (element) {
      element.userModules.forEach(function (element2) {
        if (element2.mobile == 1) {
          mythis.onlySubMenu.push(element2);
        }
      });
    });
  }
}
